<template>
  <div class="community-schedule-modal">
    <HMModalHeader
      :title="$t('COMMUNITY.TITLE.SCHEDULE_POST')"
      @close="$emit('close')"
    />
    <label>{{ $t('COMMUNITY.TEXT.WHEN_SCHEDULE_POST') }}</label>
    <form @submit.prevent="submit">
      <div class="d-flex align-items-center w-100 mt-2">
        <span class="calendar-icon mr-2 flex-shrink-0">
          <i class="far fa-calendar"></i>
        </span>
        <span class="flex-grow-1 c-charcoal">
          {{ $t('COMMUNITY.LABEL.POSTING') }}:
          <b v-if="!localReleaseOn.startDate">
            {{ $t('COMMUNITY.LABEL.IMMEDIATELY') }}
          </b>
          <b v-else>
            {{ $formatDate(localReleaseOn.startDate, 'date-time') }}
          </b>
        </span>
        <HMDateSelect
          v-model="localReleaseOn"
          :showClear="true"
          :showTime="true"
          :minDate="minimumDate"
          :openPicker="openPicker"
        >
          <a class="c-brand-color" role="button">
            <span v-if="localReleaseOn.startDate">
              {{ $t('COMMUNITY.LABEL.EDIT_DELIVERY_DATE') }}
            </span>
            <span v-else>
              {{ $t('COMMUNITY.LABEL.SCHEDULE_FOR_LATER') }}
            </span>
          </a>
        </HMDateSelect>
      </div>
      <!--      <div class="d-flex flex-row align-items-center justify-content-center">
              <HMDateSelect v-model="localReleaseOn" :showClear="true" :showTime="true">
                <a class="c-brand-color" role="button">
                  <span v-if="localReleaseOn.startDate">
                    {{ $t('PRODUCTS.LINK.EDIT_DELIVERY_DATE') }}
                  </span>
                  <span v-else>
                    {{ $t('PRODUCTS.LINK.SCHEDULE_LATER_DELIVERY') }}
                  </span>
                </a>
              </HMDateSelect>
            </div>-->
      <HMModalFooter
        class="mt-3"
        :submitButton="$t('GENERAL.BUTTON.CONFIRM')"
        :discardButton="$t('GENERAL.BUTTON.CANCEL')"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import { HMModalFooter, HMModalHeader } from '@/web/components/common';
import moment from 'moment';
import HMDateSelect from '@/web/components/common/HMDateSelect';

export default {
  name: 'CommunityScheduleModal',
  components: {
    HMModalHeader,
    HMModalFooter,
    HMDateSelect,
  },
  props: {
    releaseOn: {
      type: Date,
    },
    openPicker: {
      type: Boolean,
      default: false,
    },
    confirmFn: null,
  },
  computed: {
    minimumDate() {
      return moment().subtract(1, 'day').toDate();
    },
    releaseOnDate: {
      get() {
        return moment(this.localReleaseOn).format('YYYY-MM-DD');
      },
      set(value) {
        const selectedDate = moment(value);
        const selectedStartTime = moment(this.localReleaseOn);
        selectedDate.hour(selectedStartTime.hour());
        selectedDate.minute(selectedStartTime.minute());
        this.localReleaseOn = _.clone(selectedDate.toISOString());
      },
    },
    releaseOnTime: {
      get() {
        return moment(this.localReleaseOn).format('HH:mm');
      },
      set(value) {
        const selectedDate = moment(this.localReleaseOn);
        const selectedStartTime = moment(value, ['HH:mm']);
        selectedDate.hour(selectedStartTime.hour());
        selectedDate.minute(selectedStartTime.minute());
        this.localReleaseOn = _.clone(selectedDate.toISOString());
      },
    },
  },
  data() {
    return {
      localReleaseOn: {
        startDate: this.releaseOn,
      },
    };
  },
  methods: {
    submit() {
      this.confirmFn && this.confirmFn(this.localReleaseOn.startDate);
      this.$emit('close');
    },
  },
  async mounted() {},
  watch: {
    releaseOn: {
      handler(releaseOn) {
        this.localReleaseOn = { startDate: releaseOn };
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

::v-deep .daterangepicker {
  .applyBtn {
    background-color: var(--brand-color, $coral) !important;
    color: $white;
    border: none;
    outline: none;
  }

  .start-date {
    background-color: var(--brand-color, $coral) !important;
  }
}

.calendar-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--brand-color-with-opacity-03, $coral);
  color: var(--brand-color, $coral);
}
</style>
